// extracted by mini-css-extract-plugin
export default {"spinner":"AJGw86rnsaSuCADL7ds0","rotator":"mqa8M6zFPTtjaiS1oCq1","path":"XaytASI97fo6VyT2WkI3","dash":"OHpOeGb3oz5ZZUcxu2t6"};